import { getOIDCStateAction, userManager } from '@/auth/oidcConfig';
import { baseQueryType } from '../../../resiliency/util';

export const baseQueryWithAuth = (baseQuery: baseQueryType): baseQueryType => {
  let isRedirecting = false;
  const BaseQueryWithAuth: baseQueryType = async (...args) => {
    const result = await baseQuery(...args);

    if (result.error && result.error.status === 401 && !isRedirecting) {
      isRedirecting = true; // avoid NS_BINDING_ABORTED error when redirecting
      await userManager.signinRedirect({
        state: getOIDCStateAction(args[0], args[1].endpoint, args[2])
      });
    }

    return result;
  };

  return BaseQueryWithAuth;
};
